import { useSeoMeta } from '@unhead/react';
import { AppShell } from '@/components/AppShell';
import { Composer } from '@/components/Composer';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { LoginArea } from '@/components/auth/LoginArea';

export function ComposePage() {
  useSeoMeta({ title: 'New post — Jumble', description: 'Write a note on Nostr.' });
  const { user } = useCurrentUser();
  return (
    <AppShell title="New post">
      {user ? (
        <Composer placeholder="Share what's happening on Nostr…" autoFocus />
      ) : (
        <div className="flex flex-col items-center gap-4 p-10">
          <p className="text-muted-foreground">Log in to post.</p>
          <LoginArea />
        </div>
      )}
    </AppShell>
  );
}
